import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { blogs } from "./blogs";

const renderContent = (block, i) => {
  switch (block.type) {
    case "paragraph":
      return (
        <p key={i} className="mb-4 text-[#2D3A5A]">
          {block.parts
            ? block.parts.map((part, idx) =>
              part.bold ? (
                <span key={idx} className="font-bold text-[#091A3A]">
                  {part.bold}
                </span>
              ) : (
                <span key={idx}>{part.text}</span>
              )
            )
            : block.text}
        </p>
      );

    case "list":
      return (
        <ul key={i} className="list-disc pl-6 mb-6 text-[#2D3A5A]">
          {block.items.map((item, idx) => (
            <li key={idx} className="mb-2">
              {typeof item === "object" ? (
                <>
                  <span className="font-bold text-[#091A3A]">{item.bold}</span>
                  {item.rest}
                </>
              ) : (
                item
              )}
            </li>
          ))}
        </ul>
      );

    case "image":
      return (
        <div key={i} className="my-6">
          <img
            src={block.src}
            alt={block.alt}
            className="w-full rounded-2xl shadow-md"
          />
        </div>
      );

    case "highlight":
      return (
        <h3 key={i} className="text-xl font-bold text-[#1AAC8B] mt-6">
          {block.text}
        </h3>
      );

    case "table":
      return (
        <div key={i} className="overflow-x-auto mb-6">
          <table className="w-full border text-sm">
            <thead className="bg-[#1AAC8B] text-white">
              <tr>
                {block.headers.map((h, idx) => (
                  <th key={idx} className="p-2">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {block.rows.map((row, rIdx) => (
                <tr key={rIdx} className="border">
                  {row.map((cell, cIdx) => (
                    <td key={cIdx} className="p-2">{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );

    case "author":
      return (
        <div
          key={i}
          className="mt-10 p-5 bg-white rounded-2xl shadow flex gap-4 items-start"
        >
          {block.image && (
            <img
              src={block.image}
              alt={block.name}
              className="w-16 h-16 rounded-full object-cover"
            />
          )}

          <div>
            <h4 className="font-bold text-[#091A3A]">{block.name}</h4>
            <p className="text-sm text-[#1AAC8B] mb-2">{block.role}</p>
            <p className="text-sm text-[#6B7A99]">{block.bio}</p>
          </div>
        </div>
      );

    default:
      return null;
  }
};

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const blog = blogs.find((b) => b.id === id);

  if (!blog) return <div>Blog not found</div>;

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <div className="max-w-4xl mx-auto px-6 py-12">
        {/* Back Button */}
        <button
          onClick={() => navigate("/blogs")}
          className="flex items-center gap-2 mb-6 text-[#1AAC8B]"
        >
          <ArrowLeft size={18} /> Back
        </button>

        <h1 className="text-[26px] font-extrabold mb-6 text-[#1AAC8B]">
          {blog.title}
        </h1>

        <img
          src={blog.image}
          alt={blog.title}
          className="w-full h-72 object-cover rounded-2xl mb-6"
        />

        <div className="leading-relaxed">
          {blog.content.map((block, i) => renderContent(block, i))}
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;